import React, { useState } from 'react'
import { BASE_URL } from '../constants/urls';
import axios from 'axios';

const useDeleteUser = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const deleteUser = async (id) => {

        setLoading(true);
        setError(null);
        
        try {

            const response = await axios.delete(`${BASE_URL}/users/${id}`, {
                headers: {
                    Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
                }
            },)
            return response.data


        } catch (err) {
            setError(err);
            throw err;
        } finally {
            setLoading(false)
        }
    };

  return {deleteUser, loading, error}
}

export default useDeleteUser